module.exports = __webpack_public_path__ + "static/media/youtube.a6dd7ffe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/FooterSection/youtube.svg
// module id = 1083
// module chunks = 1